// src/Home.js
import AnimateOnScroll from './../../components/common/animate';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import React, { useState, useEffect, useRef } from 'react';
import DataService from '../../services/data.service';
import LoaderOverlay from '../common/loader.component';
import { useSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

export default function BookingStatus() {
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const [bookingStatus, setBookingStatus] = useState('');
  const [statusCode, setStatusCode] = useState('');
  const [ownerNote, setOwnerNote] = useState(''); // input from owner
  const [submitted, setSubmitted] = useState(false); // prevent multiple submissions
  const hasFetched = useRef(false);
  const navigate = useNavigate();

  const action = searchParams.get('action');
  const token = searchParams.get('token');
  const role = searchParams.get('role');

  const updateBooking = (note = '') => {
    let data = { token, status: action, role };
    if (role === 'owners') data.reason = note; // Add note only if owner

    setLoading(true);
    DataService.updateBookingStatus(data)
      .then((response) => {
        setBookingStatus(response.data.message);
        setStatusCode(response.status);
      })
      .catch((error) => {
        setStatusCode(error?.response?.status || 500);
        setBookingStatus(error?.response?.data?.error || 'Something went wrong.');
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (role !== 'owners' && !hasFetched.current) {
      hasFetched.current = true;
      updateBooking();
    }
  }, []);

  const handleOwnerSubmit = () => {
    if (!ownerNote.trim() || submitted) {
      toast.error('Please enter reason.');
      return
    };
    setSubmitted(true);
    updateBooking(ownerNote.trim());
  };

  return (
    <>
      <LoaderOverlay loading={loading} />

      <div>
        <section
          className="hero-wrap hero-wrap-2"
          style={{ backgroundImage: "url('images/thank-you.png')" }}
          data-stellar-background-ratio="0.5"
        >
          <div className="overlay" />
          <div className="container">
            <div className="row no-gutters slider-text js-fullheight align-items-center justify-content-center">
              <AnimateOnScroll className="col-md-9 text-center">
                <h1 className="mb-3 bread">Booking Status</h1>
              </AnimateOnScroll>
            </div>
          </div>
        </section>

        <section className="ftco-section thankyou-section">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10 text-center">
                <h1 className="heading mb-4">Your Status Update Request</h1>

                    {(role !== 'owners' || submitted) && (
                  <div
                    className={`alert ${
                      statusCode === 200
                        ? 'alert-success'
                        : statusCode === 400
                        ? 'alert-warning'
                        : statusCode === 403
                        ? 'alert-danger'
                        : statusCode === 404
                        ? 'alert-info'
                        : 'alert-secondary'
                    }`}
                    style={{
                      fontSize: '1.5rem',
                      fontWeight: 'bold',
                      padding: '20px',
                      borderRadius: '10px',
                    }}
                  >
                    {bookingStatus || (role === 'owners' ? '' : 'Processing your request...')}
                  </div>
                )}
                {role === 'owners' && !statusCode && (
                  <div className="mt-4">
                    <textarea
                      className="form-control"
                      placeholder="Reason"
                      value={ownerNote}
                      onChange={(e) => setOwnerNote(e.target.value)}
                      rows={4}
                      style={{ padding: '12px' }}
                      maxLength={1900}
                    />
                    <button
                      className="btn btn-primary py-3 px-5 mr-3"
                      onClick={handleOwnerSubmit}
                      style={{marginTop:'20px'}}
                    >
                      Submit
                    </button>
                  </div>
                )}

                <div className="justify-content-center mt-5 thank-yout-btn">
                  <button
                    className="btn btn-primary py-3 px-5 mr-3"
                    onClick={() => navigate('/')}
                  >
                    Back to Home
                  </button>
                  <button
                    className="btn btn-secondary py-3 px-5 mr-3"
                    onClick={() => navigate('/book-appointment')}
                  >
                    Book Another
                  </button>
                  <button
                    className="btn btn-outline-primary py-3 px-5"
                    onClick={() => navigate('/contact')}
                  >
                    Contact Us
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
